(ns rothko.theme.core
  (:require #?@(:cljs [[react :as react]
                       [reagent.core :as r]])
            [rothko.theme.manatee.core :as manatee]
            [rothko.theme.sandi.core :as sandi]
            [rothko.theme.wandi.core :as wandi]))

(def theme-names #{:sandi :wandi :mannatee})

(def themes
  {:manatee manatee/main
   :sandi sandi/main
   :wandi wandi/main})

(defn get-theme
  [theme-name]
  (get themes theme-name))

(defn get-styles
  [component-type theme]
  (get-in theme [:styles component-type]))

#?(:cljs
   (def context (.createContext react #{})))

#?(:cljs
   (defn provider
     [{:keys [theme]} comp]
     (r/create-element
      (.-Provider context)
      #js {:value theme
           :children (r/as-element comp)})))

#?(:cljs
   (defn consumer
     [{:keys [component-type]} [comp props & children]]
     (r/create-element
      (.-Consumer context)
      nil
      (fn inner [theme-name]
        (r/as-element
         (into
          [comp (merge props {:theme (get-styles component-type (get-theme theme-name))})]
          children))))))
